(function (global) {
  global.Reverb = global.Reverb || {};

  function scroll(target, callback) {
    const $target = $(target);
    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top,
      }, 300);
      return callback;
    }
  }

  global.Reverb.SmoothScroll = { scroll };
}(window));

(function () {
  function doScroll(that, callback) {
    const isPathname = location.pathname.replace(/^\//, '') === that.pathname.replace(/^\//, '');


    const isHostname = location.hostname === that.hostname;
    let target;

    if (isPathname || isHostname) {
      target = $(that.hash);
      target = target.length ? target : $(`[name=${that.hash.slice(1)}]`);
      return Reverb.SmoothScroll.scroll(target, callback);
    }
  }

  $('[data-smooth-scroll]').click(function () {
    // this returns false, preventing default actions
    return doScroll(this, false);
  });

  $('[data-smooth-scroll-and-continue]').click(function () {
    // this returns true, allowing events to continue
    // useful for allowing additional actions such as
    // hiding/showing elements
    return doScroll(this, true);
  });
}());



// WEBPACK FOOTER //
// ./src/components/legacy/dom/smooth_scrolling.js